var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-plusplus */
import { useMemo } from 'react';
import { useFetch } from '@hn-front/utils';
import { styled, ThemeProvider } from 'styled-components';
import defaultTheme from '../../../landing/components/core/themes/theme';
import { initialWeeks, splitGroupNumber, } from '../../../supervizors/components/marathons/api';
import { LeaderBoardBanner } from './banner/LeaderBoardBanner';
import { Table } from './leaderboard/Table';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-qwqqc" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var fetchProps = {
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
};
var LeaderBoard = function (_a) {
    var role = _a.role, currentTeacherId = _a.currentTeacherId, rest = __rest(_a, ["role", "currentTeacherId"]);
    var paths = window.location.pathname.split('/');
    var marathonInd = paths.findIndex(function (p) { return p === 'challenges'; });
    var marathonId = paths[marathonInd + 1];
    var marathonResponse = useFetch("/api/v2/" + (role === 'teacher' ? 'teachers' : 'supervizors') + "/marathons/" + marathonId, fetchProps).response;
    var leaderboardResponse = useFetch("/api/v2/" + (role === 'teacher' ? 'teachers' : 'supervizors') + "/marathons/" + marathonId + "/leaderboard", fetchProps).response;
    var _b = marathonResponse || {}, endAt = _b.endAt, _c = _b.currentWeekNumber, currentWeekNumber = _c === void 0 ? 4 : _c, status = _b.status;
    var leaderBoardData = useMemo(function () {
        return leaderboardResponse === null || leaderboardResponse === void 0 ? void 0 : leaderboardResponse.items.map(function (d, index) {
            var leaderBoard = {
                rank: d.rank,
                position: index + 1,
                gradeValue: d.grade.value,
                groupNumber: splitGroupNumber(d.group.number),
                teacherEmail: d.teacher.email,
                totalPoints: d.score,
                weeks: __spreadArray([], initialWeeks, true),
                own: currentTeacherId === d.teacher.id,
            };
            for (var ind = 0; ind < d.weeklyStats.length; ind++) {
                var week = d.weeklyStats[ind];
                leaderBoard.weeks[ind] = __assign(__assign({}, leaderBoard.weeks[ind]), { points: week.score, students: week.attended, timeSpent: week.minutesSpent, totalStudents: week.rostered, bonus: week.bonus });
            }
            return leaderBoard;
        });
    }, [leaderboardResponse, currentTeacherId]);
    var hasCertificates = leaderBoardData === null || leaderBoardData === void 0 ? void 0 : leaderBoardData.some(function (d) { return d.rank; });
    return (_jsx(ThemeProvider, __assign({ theme: defaultTheme }, { children: _jsxs(Container, __assign({}, rest, { children: [endAt && (_jsx(LeaderBoardBanner, { startWeek: currentWeekNumber, endWeek: 4, endDate: endAt, marathonId: marathonId, role: role, marathonStatus: status, canDownload: hasCertificates }, void 0)), leaderBoardData && _jsx(Table, { data: leaderBoardData }, void 0)] }), void 0) }), void 0));
};
export default LeaderBoard;
var templateObject_1;
